/*
 * @Description:
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2022-11-22 20:05:43
 * @LastEditors: Monkey
 * @LastEditTime: 2026-01-19 18:16:40
 */
import tool from '@/utils/tool';
import config from "@/config";

const KEY_USER_INFO = "USER_INFO";
const getUserParam = (key) => {
  const userInfo = tool.data.get(KEY_USER_INFO);
  return userInfo === undefined || userInfo == null ? '' : userInfo[key];
};

export default {
  namespaced: true,
  state: {
    userName: getUserParam('userName'),
    isDefaultPd: getUserParam('isDefaultPd'),
    isJurisdiction: getUserParam('isJurisdiction'),
    filialeId: getUserParam('filialeId'),
  },
  mutations: {
    setToken(state, token) {
      tool.cookie.set(config.TOKEN_COOKIE_KEY, token);
    },
    setUser(state, userInfo) {
      tool.data.set(KEY_USER_INFO, userInfo);
      state.filialeId = userInfo.filialeId;
      state.userName = userInfo.userName;
      state.isDefaultPd = userInfo.isDefaultPd;
      state.isJurisdiction = userInfo.isJurisdiction;
    },
    setUserSite(state, userSite) {
      tool.data.set('USER_SITE', userSite);
    },
    setMenu(state, menus) {
      tool.data.set('MENU', menus);
    },
    setPermissions(state, permissions) {
      tool.data.set('PERMISSIONS', permissions);
    }
  },
  actions: {
    login({ dispatch, commit }, loginData) {
      return new Promise((resolve) => {
        // console.log(loginData)
        commit('setToken', loginData.user.token);
        commit('setUser', loginData.user);
        commit('setMenu', loginData.userAuth.menus);
        commit('setPermissions', loginData.userAuth.permissions);

        // 设置默认值
        const userSite = {
          drawerWidth: '0'
        }
        if (loginData.userSite != null) {
          userSite.drawerWidth = loginData.userSite.drawerWidth;
        }
        commit('setUserSite', userSite);
        // // this.$TOOL.data.set("PERMISSIONS", menu.data.permissions)

        // 保存公司信息
        dispatch('company/saveCompany', loginData.company, { root: true });
        resolve();
      });
    }
  }
};
